import { Navigate, useParams } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { getAccessType } from '../utils/permissions';

/**
 * Composant de protection des routes selon les permissions
 * Utilisé pour protéger les routes qui nécessitent un accès complet
 * (exemple: évaluations, résultats, savoir-faire)
 *
 * @param {React.ReactNode} children - Composants enfants à protéger
 * @param {'full' | 'restricted'} requiredAccess - Type d'accès requis (par défaut 'full')
 */
const RestrictedRoute = ({ children, requiredAccess = 'full' }) => {
  const { idclasse } = useParams();
  const { user, etablissementData } = useUser();

  // Vérifier que nous avons les données nécessaires
  if (!user || !etablissementData || !idclasse) {
    return <Navigate to="/" replace />;
  }

  // Obtenir le type d'accès de l'utilisateur pour cette classe
  const accessType = getAccessType(parseInt(idclasse, 10), user, etablissementData);

  // Si l'utilisateur n'a aucun accès, rediriger vers la page d'accueil
  if (accessType === 'none') {
    return <Navigate to="/" replace />;
  }

  // Si l'accès requis est 'full' mais l'utilisateur a 'restricted', rediriger
  if (requiredAccess === 'full' && accessType === 'restricted') {
    // Rediriger vers la page des élèves (seule page autorisée en accès restreint)
    return <Navigate to={`/home/detail/${idclasse}`} replace />;
  }

  // Si toutes les vérifications passent, afficher les enfants
  return children;
};

export default RestrictedRoute;
